module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Layers-7603d5eb321f201d2927d5832257bd1b9410aa35eb2ccec99199e90a5cd84335.svg";